import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function AboutUs() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pt-20 lg:pt-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate("/support")}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8 transition-colors"
        >
          <ArrowLeft size={20} weight="bold" />
          <span className="font-medium">Back to Support</span>
        </button>

        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-black text-[#0F172A] mb-4">About Us</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Learn about Loado's mission, values, and the construction ecosystem we are building for customers, sellers and delivery partners.
          </p>
        </div>

        <div className="space-y-8 text-slate-600">
          <section className="space-y-4">
            <p>
              Welcome to <strong>Loado</strong>, the flagship digital platform of <strong>Goodskart Logistics & Retail Service Pvt Ltd</strong>. Headquartered in the vibrant hub of Chennai, we are on a mission to revolutionize the way India builds.
            </p>
            <p>
              In an industry often slowed down by fragmented logistics and opaque material pricing, Loado stands as a bridge of efficiency. We have combined high-tech logistics with a transparent retail marketplace to create a <strong>"One-Stop Construction Ecosystem."</strong>
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">Who We Are</h2>
            <p>
              At Goodskart, we recognized a massive gap in the construction sector: contractors struggled to find reliable trucks, and material stores struggled to reach new sites. <strong>Loado was born to solve both.</strong> Whether it's a single bag of cement delivered via a bike or 20 tons of steel moved by a heavy-duty tipper, we ensure that the right materials reach the right site at the right time.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">Our Core Pillars</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">🏗️</span>
                  <div>
                    <h3 className="font-bold text-[#0F172A] mb-1">Versatility</h3>
                    <p className="text-sm text-slate-600">From Bikes to Heavy Trucks, our fleet is designed for every construction need—no matter how small or large.</p>
                  </div>
                </div>
              </div>
              <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">💎</span>
                  <div>
                    <h3 className="font-bold text-[#0F172A] mb-1">Transparency</h3>
                    <p className="text-sm text-slate-600">With Real-Time Material Pricing and Pay-After-Delivery Logistics, we put the power back into the hands of the builders.</p>
                  </div>
                </div>
              </div>
              <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">🛡️</span>
                  <div>
                    <h3 className="font-bold text-[#0F172A] mb-1">Trust & Verification</h3>
                    <p className="text-sm text-slate-600">We don't just move goods; we move them safely. Every Seller and Delivery Partner on our platform undergoes rigorous KYC verification.</p>
                  </div>
                </div>
              </div>
              <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">🚀</span>
                  <div>
                    <h3 className="font-bold text-[#0F172A] mb-1">Efficiency</h3>
                    <p className="text-sm text-slate-600">Our "One-Day Delivery" promise is backed by smart routing algorithms that navigate the unique challenges of Indian construction sites.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="font-bold text-[#0F172A] text-xl">Our Vision</h2>
            <p>
              To become the <strong>digital backbone of the Indian construction industry</strong>. We aim to empower every local material store to go digital and every truck owner to find consistent, high-value work—all while helping builders complete their projects faster and more affordably.
            </p>
          </section>

          <section className="p-4 bg-[#0F172A] text-white rounded-lg">
            <h2 className="font-bold mb-3">Registered Office</h2>
            <p className="text-slate-300 mb-2">
              <strong className="text-white">Goodskart Logistics & Retail Service Pvt Ltd</strong>
              <br />
              NO 19/35 V403 First Floor, Mount Road,
              <br />
              Little Mound, Saidapet,
              <br />
              Chennai - 600015, Tamil Nadu, India.
            </p>
            <p className="text-slate-300">
              <strong className="text-white">Support:</strong> support@loado.in
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
